import { useNavigate } from "react-router-dom";
import {
    Row,
    Navbar,
    NavbarBrand,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import { useState } from "react";

const Nav = ({
    activeDashboardTab,
    setDashboardTab,
}) => {
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setDropdownOpen((currentValue) => !currentValue);
    };

    const handleLogout = () => {
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        navigate("/login");  // Redirect after logout
    };

    return (
        <Row>
          <Navbar className="mb-2 navbar-scheme">
            <NavbarBrand href="/" className="navbar-scheme navbar-brand-icon">
              <img
                src="/icon-lfx-192.svg"
                alt="Limitless FX"
                className="navbar-app-icon"
              />
            </NavbarBrand>
            <Dropdown
              isOpen={dropdownOpen}
              toggle={toggleDropdown}
              className="ms-auto dashboard-nav-dropdown"
            >
              <DropdownToggle
                caret
                className="brand-action-button dashboard-menu-toggle"
              >
                <span className="visually-hidden">Open navigation menu</span>
              </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem
                  active={activeDashboardTab === "active"}
                  onClick={() => setDashboardTab("active")}
                >
                  Dashboard
                </DropdownItem>
                <DropdownItem
                  active={activeDashboardTab === "past"}
                  onClick={() => setDashboardTab("past")}
                >
                  Past Performance
                </DropdownItem>
                <DropdownItem
                  active={activeDashboardTab === "transactions"}
                  onClick={() => setDashboardTab("transactions")}
                >
                  Transactions
                </DropdownItem>
                <DropdownItem
                  active={activeDashboardTab === "settings"}
                  onClick={() => setDashboardTab("settings")}
                >
                  Settings
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={handleLogout}>
                  Logout
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Navbar>
          
        </Row>
    );
};

export default Nav;
